module.exports = __webpack_public_path__ + "img/postfach.e25fd594.png";